import React from "react";
import Label from "./Label";
import useMediaQuery from "../hooks/useMediaQuery";

const Select = ({ value, onChange, name, label, errorMessage, data, defaultValue, showLabel = true }) => {
  const isError = errorMessage ? true : false;
  const errorClass = isError ? "border-error-dark" : "border-accent";

  const isRpiScreen = useMediaQuery("(min-width: 1200px)");
  const textClass = isRpiScreen ? "text-4xl h-20" : "h-10";
  return (
    <div className="flex flex-col">
      <Label name={name} errorMessage={errorMessage} label={label} showLabel={showLabel} />
      <select
        name={name}
        id={name}
        onChange={onChange}
        defaultValue={value}
        // value={value}
        className={`border rounded-xl            
          select-none ${textClass} px-4 inset-shadow-xl focus:outline-none bg-white focus:bg-accent-secondarya selection:bg-accent-secondary selection:text-black ${errorClass}`}
      >
        {data &&
          data.map((item) => (
            <option key={item.value} disabled={item.value === defaultValue ? true : false} value={item.value}>
              {item.label}
            </option>
          ))}
      </select>
    </div>
  );
};

export default Select;
